import { decrypt } from '@/api/buyTicket'
export const decryptMixin = {
  methods: {
    decrypt(row, name) {
      if (!row[name + '2']) {
        const param = [row[name + 'Encrypt']]
        decrypt(param).then(res => {
          if (res.code === 0) {
            this.$set(row, name + '2', res.data[0])
          } else {
            this.$message.error(res.error)
          }
        })
      } else {
        row[name + '2'] = null
      }
    }
  }
}
